import { useState } from "react";
import useEvaApi, { EvaApiCall } from "../../../../hooks/useEvaApi";
import EmployeeRegistrationPageView from "./EmployeeRegistrationPageView";
import useCustomEffect from "../../../../hooks/useCustomEffect";

function EmployeeRegistrationPage() {
  const callEvaApi = useEvaApi();

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  // Determine which departments to show based on the selected department
  const visibleDepartments = departments.filter(
    (department) =>
      department.parent === (selectedDepartment ? selectedDepartment.id : null),
  );

  // Determine which employees to show based on the selected department
  const filteredEmployees = employees
    .filter((employee) => {
      if (!selectedDepartment) return employee.department === null;
      return employee.department === selectedDepartment.id;
    })
    .sort((a, b) => {
      return `${a.name}`.localeCompare(`${b.name}`);
    });

  /**
   * initialize the component
   */
  useCustomEffect(() => {
    fetchDepartments();
    fetchEmployees();
  });

  /**
   * This method will fetch the current company's departments from the API
   */
  async function fetchDepartments() {
    await callEvaApi(
      new EvaApiCall("departments")
        .setLoadingGroup("employee_registration_fetch")
        .setOnSuccess((response) => {
          setDepartments(response.data.data.records);
        }),
    );

    setIsFetching(false);
  }

  /**
   * This method will fetch the employees from the API
   */
  async function fetchEmployees() {
    await callEvaApi(
      new EvaApiCall("employees")
        .setLoadingGroup("employee_registration_fetch")
        .setOnSuccess((response) => {
          setEmployees(response.data.data.records);
        }),
    );
  }

  /**
   * This method will toggle the employee presence based on the current presence status of the employee
   * @param {*} employee
   */
  async function toggleEmployeePresence(employee) {
    const isCurrentlyPresent = employee.present;
    const presenceEndpoint = isCurrentlyPresent ? "sign_out" : "sign_in";

    await callEvaApi(
      new EvaApiCall(`employees/${employee.id}/${presenceEndpoint}`)
        .setMethod("POST")
        .setLoadingGroup(`employee_registration_toggle_${employee.id}`)
        .setAlertSuccess(false)
        .setOnSuccess((response) => {
          const employee = response.data.data;
          setEmployees((prev) =>
            prev.map((emp) =>
              emp.id === employee.id
                ? { ...emp, present: employee.present }
                : emp,
            ),
          );
        }),
    );
  }

  return (
    <EmployeeRegistrationPageView
      departments={departments}
      selectedDepartment={selectedDepartment}
      setSelectedDepartment={setSelectedDepartment}
      visibleDepartments={visibleDepartments}
      filteredEmployees={filteredEmployees}
      toggleEmployeePresence={toggleEmployeePresence}
      isFetching={isFetching}
    />
  );
}

export default EmployeeRegistrationPage;
